import { isFiniteNumber } from "./is-finite-number";

export const roundToClosest = (value: number, closestTo: number): number => {
  if (!isFiniteNumber(value) || !isFiniteNumber(closestTo)) return NaN;
  closestTo = Math.abs(1 / closestTo);
  return Math.round(value * closestTo) / closestTo;
};
